(function () {
  const sections = document.querySelectorAll('[data-barf-how-steps]');
  if (!sections.length) return;

  sections.forEach((section) => {
    section.classList.add('fbhs-js');

    const revealItems = section.querySelectorAll('.fbhs-reveal, .fbhs-reveal-step');
    const revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('fbhs-is-visible');
        revealObserver.unobserve(entry.target);
      });
    }, {
      threshold: 0.16,
      rootMargin: '0px 0px -42px 0px'
    });

    revealItems.forEach((item, index) => {
      if (!item.style.getPropertyValue('--fbhs-delay')) {
        item.style.setProperty('--fbhs-delay', `${index * 80}ms`);
      }
      revealObserver.observe(item);
    });
  });
})();
